// Centroid coordinates [lon, lat] for the countries the app supports.
// Used for plotting dots on the world map in the admin geo dashboard.
// Source: rough country centers (CIA factbook + ad-hoc).
export const COUNTRY_CENTROIDS = {
  US: [-98.5, 39.8],   CA: [-106.3, 56.1], GB: [-3.4, 55.4], AU: [134.5, -25.7],
  NZ: [171.5, -41.0],  IE: [-8.2, 53.1],   DE: [10.4, 51.2], FR: [2.2, 46.6],
  ES: [-3.7, 40.2],    IT: [12.6, 41.9],   PT: [-8.0, 39.5], NL: [5.3, 52.1],
  BE: [4.6, 50.6],     CH: [8.2, 46.8],    AT: [14.6, 47.5], LU: [6.1, 49.8],
  DK: [10.0, 56.0],    SE: [16.7, 62.0],   NO: [10.7, 64.5], FI: [25.7, 64.9],
  IS: [-19.0, 64.9],   PL: [19.1, 52.0],   CZ: [15.4, 49.8], SK: [19.7, 48.7],
  HU: [19.5, 47.2],    RO: [25.0, 45.9],   BG: [25.5, 42.7], HR: [15.5, 45.1],
  SI: [14.8, 46.1],    LT: [23.9, 55.2],   LV: [24.6, 56.9], EE: [25.0, 58.6],
  UA: [31.2, 48.4],    BY: [27.6, 53.7],   RU: [105.3, 61.5], MD: [28.4, 47.4],
  TR: [35.2, 39.0],    MX: [-102.5, 23.6], BR: [-51.9, -14.2], AR: [-63.6, -38.4],
  CL: [-71.5, -35.7],  CO: [-74.3, 4.6],   PE: [-75.0, -9.2], UY: [-55.8, -32.5],
  DO: [-70.2, 19.0],   CR: [-83.7, 9.7],   GT: [-90.2, 15.8], JP: [138.3, 36.2],
  IN: [78.9, 20.6],    PK: [69.3, 30.4],   BD: [90.3, 23.7], LK: [80.8, 7.9],
  TH: [101.0, 15.9],   MY: [101.9, 4.2],   PH: [121.8, 12.9], ZA: [22.9, -30.6],
  DZ: [1.7, 28.0],     MA: [-7.1, 31.8],   AD: [1.5, 42.5],   MC: [7.4, 43.7],
  VA: [12.5, 41.9],    SM: [12.5, 43.9],   MT: [14.4, 35.9],  LI: [9.6, 47.2],
  MK: [21.7, 41.6],    PR: [-66.6, 18.2],  GU: [144.8, 13.4], VI: [-64.9, 18.3],
  AS: [-170.7, -14.3], MP: [145.6, 15.1],  MH: [171.1, 7.1],
};

// Approximate state centroids [lon, lat] for the lower 48 + AK + HI + DC + PR.
export const US_STATE_CENTROIDS = {
  AL: [-86.79, 32.81], AK: [-152.40, 64.20], AZ: [-111.66, 34.17], AR: [-92.43, 34.97],
  CA: [-119.68, 37.18], CO: [-105.55, 39.00], CT: [-72.74, 41.62], DE: [-75.51, 38.99],
  DC: [-77.03, 38.90], FL: [-81.78, 28.07], GA: [-83.43, 32.65], HI: [-156.34, 20.79],
  ID: [-114.61, 44.24], IL: [-89.20, 40.05], IN: [-86.28, 39.89], IA: [-93.50, 42.07],
  KS: [-98.38, 38.49], KY: [-84.86, 37.53], LA: [-91.89, 31.06], ME: [-69.27, 45.37],
  MD: [-76.78, 39.06], MA: [-71.81, 42.26], MI: [-85.41, 44.35], MN: [-94.30, 46.28],
  MS: [-89.66, 32.74], MO: [-92.46, 38.36], MT: [-109.63, 46.97], NE: [-99.79, 41.53],
  NV: [-116.65, 39.36], NH: [-71.58, 43.69], NJ: [-74.66, 40.20], NM: [-106.11, 34.41],
  NY: [-75.54, 42.95], NC: [-79.39, 35.55], ND: [-100.46, 47.45], OH: [-82.79, 40.29],
  OK: [-97.49, 35.31], OR: [-120.56, 43.94], PA: [-77.79, 40.88], PR: [-66.59, 18.22],
  RI: [-71.51, 41.68], SC: [-80.94, 33.92], SD: [-100.22, 44.45], TN: [-86.69, 35.86],
  TX: [-99.34, 31.05], UT: [-111.67, 39.32], VT: [-72.66, 44.07], VA: [-78.81, 37.52],
  WA: [-120.45, 47.38], WV: [-80.61, 38.64], WI: [-89.91, 44.62], WY: [-107.55, 42.99],
};

// Project equirectangular: lon ∈ [-180,180], lat ∈ [-90,90] → SVG [0,W] × [0,H]
export function projectEquirect(lon, lat, w, h) {
  const x = ((lon + 180) / 360) * w;
  const y = ((90 - lat) / 180) * h;
  return [x, y];
}

// Project to a US-only viewport (continental US-ish bounds).
// Alaska + Hawaii + PR get pinned to insets — see RoninGeoDashboard for handling.
export function projectUS(lon, lat, w, h) {
  // Continental US: lon -125 to -66, lat 24 to 50
  const xMin = -125, xMax = -66, yMin = 24, yMax = 50;
  const x = ((lon - xMin) / (xMax - xMin)) * w;
  const y = ((yMax - lat) / (yMax - yMin)) * h;
  return [x, y];
}
